export default "__VITE_ASSET__Cx66sZLa__"